// extracted by mini-css-extract-plugin
export default {"button":"_1yQSX","link":"_32iSc","orderInformation":"_27bML","orderNumber":"_1t9eu","placedOn":"_29IM-","tickets":"_2R0oH","summaryDetails":"_1QhHA","actions":"_1ovLa"};